import { securedAxios } from "../lib/axios";
import urljson from "../lib/urljson";

export default {
  namespaced: true,
  state: {
    Itens: [],
  },
  mutations: {
    carregar(state, Itens) {
      state.Itens = [];
      state.Itens = Itens;
    },
  },
  actions: {
    async listar({ commit }, opcoes) {
      try {
        const response = await securedAxios.get(
          `/item?opcoes=${urljson(opcoes)}`
        );
        commit("carregar", response.data);
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async gravar(context, itemInfo) {
      try {
        if (itemInfo.id == "") {
          delete itemInfo.id;
          await securedAxios.post("/item", itemInfo);
        } else {
          var id = itemInfo.id;
          delete itemInfo.id;
          await securedAxios.put("/item/" + id, itemInfo);
        }

        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    carregarItem(context, id) {
      return securedAxios.get(`/item/${id}`);
    },
    carregarItens() {
      return securedAxios.get("/item");
    },
    async carregarBancos() {
      return securedAxios.get("/bancos");
    },
    async deletar(context, id) {
      try {
        const response = await securedAxios.delete("/item/" + id.id);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async carregarUnidadesMedidas() {
      return securedAxios.get("/unidademedida");
    },
    async carregarGruposItens() {
      return securedAxios.get("/grupoitem");
    },
    async carregarSubGruposItens() {
      return securedAxios.get("/sub-grupo-item");
    },
  },
};
